function processResponseEnrolleeSaved(response, toastMethod) {
  if (response.code >= 200 && response.code < 300) {
    toastMethod(true, 'Enrollees Saved Successfully');
  } else {
    const errorDetails = getErrorDataFromResponse(response);
    toastMethod(false, 'There was an error: ', errorDetails.message);
  }
  return alert;
}

function getErrorDataFromResponse(response) {
    // error message could be found in one of these areas:
    // - response.data.errors.errors[0].field
    // - response.data.errors[0].message.messages.errors[0].field
    // - response.data.errors[0].message.message
    // - response.data.errors[0].message
    // - response.message (Backend 500 Errors)
    // - response.data.message
    // - response.statusText

    const defaultMessage = 'Check browser console and/or contact system administrator to check API logs.';

    // Handle 500 errors and other server errors first
    if (response?.status >= 500 || response?.code >= 500) {
        return {
            code: response?.status || response?.code || 500,
            message: response?.message || response?.statusText || 'Server error occurred. Please try again later.',
            consoleMessage: response?.message || response?.statusText || 'Server error (500+)',
        };
    }

    // Try to extract error details from various possible structures
    let extractedMessage = null;
    let consoleMessage = null;

    // Check for response.data.errors structure
    if (response?.data?.errors) {
        if (Array.isArray(response.data.errors)) {
            // Handle array of errors
            if (response.data.errors.length > 0) {
                const firstError = response.data.errors[0];

                // Try different nested structures
                if (firstError?.message?.messages?.errors && Array.isArray(firstError.message.messages.errors)) {
                    const nestedError = firstError.message.messages.errors[0];
                    extractedMessage = nestedError?.field || nestedError?.message || firstError.message;
                } else if (firstError?.message?.message) {
                    extractedMessage = firstError.message.message;
                } else if (firstError?.message) {
                    extractedMessage = firstError.message;
                } else if (firstError?.field) {
                    extractedMessage = firstError.field;
                }

                consoleMessage = firstError;
            }
        } else if (typeof response.data.errors === 'object') {
            // Handle single error object
            if (response.data.errors.errors && Array.isArray(response.data.errors.errors)) {
                const nestedError = response.data.errors.errors[0];
                extractedMessage = nestedError?.field || nestedError?.message;
                consoleMessage = nestedError;
            } else {
                extractedMessage = response.data.errors.message || response.data.errors.field;
                consoleMessage = response.data.errors;
            }
        }
    }

    // Fallback to other possible error locations
    if (!extractedMessage) {
        if (response?.data?.message) {
            extractedMessage = response.data.message;
        } else if (response?.message) {
            extractedMessage = response.message;
        } else if (response?.statusText) {
            extractedMessage = response.statusText;
        }
    }

    // If we still don't have a message, use the response object itself for console logging
    if (!consoleMessage) {
        consoleMessage = response;
    }

    return {
        code: response?.status || response?.code || 500,
        message: extractedMessage ? formatToastMessage(extractedMessage) : defaultMessage,
        consoleMessage: consoleMessage,
    };
}

// Format errors into user-friendly toast message
function formatToastMessage(error) {
    const err = error.toLowerCase();
    let errField;
    
    switch (true) {
        case err.includes('addressprimary'):
            errField = 'primary street address';
            break;
        case err.includes('addresssecondary'):
            errField = 'mailing street address';
            break;
        default:
            errField = null;
            break;
    }
    
    return !!errField ? 'Please provide a valid ' + errField + '.' : error;
}

function processEnrolleeSavedError(error) {
  console.error(error);
  this.isLoading = false;
}

function isEmptyObject(obj) {
  let returnVal = false;
  if (obj && Object.keys(obj).length == 0) returnVal = true;
  return returnVal;
}

/**
 * Removes empty values from object
 * @param obj Object to strip empty values from
 * @returns stripped object, or null
 */
function removeEmptyProperties(obj) {
  let resObj = null;

  if (!this.isEmptyObject(obj)) {
    const stringfiedObj = JSON.stringify(obj, (key, value) => {
      return ['', null].includes(value) || (typeof value === 'object' && (value.length === 0 || Object.keys(value).length === 0)) ? undefined : value;
    });
    resObj = JSON.parse(stringfiedObj);
    const isEmptyPropsPresent = ['{}', '[]', '""', 'null'].some((key) => stringfiedObj.includes(key));
    if (isEmptyPropsPresent) {
      return this.removeEmptyProperties(resObj);
    }
  }
  return resObj;
}

// function to handle error toast message in enrollment presentation in case api fails
function processResponseEnrolleePresentationSaved(response, toastMethod) {
  if (!response.status) {
    toastMethod(true, 'Saved Successfully');
  } else {
    const errorDetails = getErrorDataFromResponse(response)
    toastMethod(false, 'Error', errorDetails.message);
    console.error(errorDetails.consoleMessage)
  }

  return alert;
}

export default { processEnrolleeSavedError, processEnrolleeSavedResponse: processResponseEnrolleeSaved, isEmptyObject, removeEmptyProperties, processEnrolleePresentationSavedResponse:processResponseEnrolleePresentationSaved };
